export default "/images/891cf4dad2944fcbeb9bb1952a384309.avif";